import { Link } from "react-router-dom";

import AppFooter from "../components/AppFooter";
import LegalDocument from "../components/LegalDocument";
import type { LegalDoc } from "../legal/content.generated";

// Öffentliche Rechtsseite (Impressum/Datenschutz) — ausserhalb des Logins
// erreichbar, eigenes schlankes Layout statt der App-Shell.
export default function LegalPage({ doc }: { doc: LegalDoc }) {
  return (
    <div className="flex min-h-full flex-col">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex h-14 max-w-7xl items-center px-4 sm:px-6">
          <Link
            to="/"
            className="flex-none text-base font-semibold tracking-tight text-slate-950"
          >
            Truu<span className="text-emerald-600">Cost</span>
          </Link>
        </div>
      </header>
      <main className="flex-1">
        <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6">
          <LegalDocument doc={doc} />
          <p className="mt-12 border-t border-slate-100 pt-6">
            <Link
              to="/"
              className="text-sm font-medium text-emerald-700 hover:text-emerald-800"
            >
              ← Zurück
            </Link>
          </p>
        </div>
      </main>
      <AppFooter />
    </div>
  );
}
